
import uniqueid from 'lodash.uniqueid';
import InputProps from './mixins/InputProps';
import {
  InputEventType,
  InputFillType,
  InputProperty,
  InputSlotType,
} from './enums';
import StyleClassNamesBuilder from '../../../../../styles/helpers/StyleClassNamesBuilder';
import Spinner from '../../../../spinner';

export default {
  name: 'Input',
  components: {
    Spinner,
  },
  mixins: [InputProps],
  data() {
    return {
      isFocused: false,
      InputProperty,
      InputSlotType,
      inputId: uniqueid(this.$options.name),
    };
  },
  computed: {
    inputClassName() {
      return new StyleClassNamesBuilder('input')
        .addColorSchemeConditionClassNames(this[InputProperty.ColorScheme])
        .addConditionClassNames(Object.values(InputFillType), this[InputProperty.FillType])
        .addConditionClassName('disabled', this[InputProperty.Disabled])
        .addConditionClassName('focused', this.isFocused)
        .build();
    },
    inputControlClassName() {
      return new StyleClassNamesBuilder('input__control')
        .build();
    },
    inputLabelClassNames() {
      return new StyleClassNamesBuilder('input__label')
        .addConditionClassName('under-border', this.isLabelUnderBorder)
        .build();
    },
    isLabelUnderBorder() {
      return this.isFocused
        || this.hasValue
        || this[InputProperty.Placeholder]
        || this.hasPrependSlot;
    },
    hasPrependSlot() {
      return !!this.$scopedSlots[InputSlotType.Prepend];
    },
    hasAppendSlot() {
      return !!this.$scopedSlots[InputSlotType.Append];
    },
    hasValue() {
      const value = this[InputProperty.Value];

      return value?.toString().length;
    },
  },
  methods: {
    handleInput(event) {
      this.$emit(InputEventType.Input, event);
    },
    handleChange(event) {
      this.$emit(InputEventType.Change, event);
    },
    handleFocus(event) {
      this.$emit(InputEventType.Focus, event);
      this.isFocused = true;
    },
    handleBlur(event) {
      this.$emit(InputEventType.Blur, event);
      this.isFocused = false;
    },
  },
};
